import { MOKA_SERVICE_HOST, API_URL } from '../constants';

const MOKA_SERVICE_PAYMENT = `${MOKA_SERVICE_HOST}/payment`;

export const PAYMENT_METHODS = `${MOKA_SERVICE_PAYMENT}/v1/payment-methods`;

export const PAYMENT_METHOD_REGISTRATIONS = `${MOKA_SERVICE_PAYMENT}/v1/registrations`;
export const PAYMENT_METHOD_BULK_REGISTRATIONS = `${MOKA_SERVICE_PAYMENT}/v1/registrations/bulk`;
export const PAYMENT_METHOD_REGISTRATION_STATUS = `${MOKA_SERVICE_PAYMENT}/v1/registrations/check-all-registrations`;
export const PAYMENT_METHOD_ACTIVATE_PAYMENT_METHOD = `${MOKA_SERVICE_PAYMENT}/v1/registrations/activate-all-registrations`;
export const PAYMENT_METHOD_KYB_STATUS = `${MOKA_SERVICE_HOST}/business-service/v1/business`;
export const PAYMENT_METHOD_OUTLET_BANK_STATUS = `${API_URL}/v1/bank_accounts/outlets_status`;
